import { FlagUz, FlagRu, FlagEn } from "assets/images/icons";

function gen4() {
  return Math.random()
    .toString(16)
    .slice(-4);
}

const HtmlContent = ({ html }: { html: string }) => {
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

const langlist = [
  { id: 1, title: "O'zbekcha", shortName: "O'z" },
  { id: 2, title: "Русский", shortName: "Ру" },
  { id: 3, title: "English", shortName: "En" },
];

const bannerType = [
  { id: 1, name: "Vertikal", type: "vertical" },
  { id: 2, name: "Gorizontal", type: "horizontal" },
];

export { gen4, langlist, HtmlContent, bannerType };
